
import { motion } from "framer-motion";

export const EntriesLoader = () => {
  return (
    <div className="text-center py-12">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="space-y-4"
      >
        <div className="flex justify-center">
          <motion.div
            animate={{ 
              rotate: 360,
              scale: [1, 1.1, 1],
            }}
            transition={{ 
              repeat: Infinity, 
              duration: 2,
            }}
            className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full"
          />
        </div>
        <p className="text-gray-600 italic">Loading your cooking memories...</p>
      </motion.div>
    </div>
  );
};
